document.addEventListener("DOMContentLoaded", () => {
  const puzzles = [...document.querySelectorAll(".puzzle")]
  if (puzzles.length === 0) return

  // On phones the puzzle sits below the hero text, so the pieces would slot in before anyone sees
  // them. They wait until the puzzle comes on screen. The class is added here, so without the
  // script the animation simply plays on load.
  puzzles.forEach((puzzle) => puzzle.classList.add("puzzle--waiting"))

  const observer = new IntersectionObserver((entries) => {
    entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
      entry.target.classList.remove("puzzle--waiting")
      observer.unobserve(entry.target)
    })
  }, { threshold: 0.15 })

  puzzles.forEach((puzzle) => observer.observe(puzzle))
})
